import stickybits from 'stickybits'
import deBounce from 'lodash.debounce'

// this script supports both floating and sticky forms
$(document).ready(function () {

    if ($('.floating-form').length)
        setupFloatingForm();

    if ($('#vertical-form').length) {
        $('#vertical-form')
            .closest('.columns').addClass('v-form-wrapper')
            .siblings('.columns').addClass('vertical-form-wrapper')
            .closest('.main-with-sidebar').addClass('with-sticky-form');

        // only affects hva
        $('#vertical-form').closest('.xlarge-push-8').removeClass('xlarge-push-8').addClass('large-push-8')
            .siblings('.xlarge-pull-4').removeClass('xlarge-pull-4').addClass('large-pull-4');

        var offset = 20;
        if ($('#header-form').length)
            offset = 120;

        stickybits('#vertical-form', { stickyBitStickyOffset: offset });
    }
});

function setupFloatingForm() {
    $('.floating-form').closest('.columns').addClass('v-form-wrapper').siblings('.columns').addClass('vertical-form-wrapper');

    $('#page').addClass('with-floating-form');

    $(window).on('resize', function () {
        let hero = $('.hero');
        if (hero.length) {
            if (Foundation.mediaQuery.MediaQuery.atLeast('xlarge')) {
                let heroHeight = hero.height();
                $('.floating-form').css('top', '-' + heroHeight + 'px');
            } else {
                $('.floating-form').css('top', '');
            }
        }
    }).trigger('resize');
}

$(document).ready(function () {
    // add modifier class to elem based on its width
    // in the future, we can do this with container queries, but they aren't working with our current sass setup
    var $verticalLeadFormV2 = $('.verticalLeadFormV2');
    var wideMinWidth = 400;

    if ($verticalLeadFormV2.length === 0) {
        return;
    }

    function updateVerticalLeadFormV2() {
        if ($verticalLeadFormV2.width() >= wideMinWidth) {
            $verticalLeadFormV2.addClass('verticalLeadFormV2--wide');
        } else {
            $verticalLeadFormV2.removeClass('verticalLeadFormV2--wide');
        }

        // set tabindex for input and select elements after reorder
        var tabindex = 1;
        $('.verticalLeadFormV2__fieldGroupContainer').children().sort(function (a, b) {
            return ($(a).css('order') || 0) - ($(b).css('order') || 0);
        }).each(function () {
            $(this).find('input, select').each(function () {
                $(this).attr('tabindex', tabindex++);
            });
        });
    }

    updateVerticalLeadFormV2();

    $(window).on('resize', deBounce(function () {
        updateVerticalLeadFormV2();
    }, 50));
});
